module.exports = "/static/media/phone.8d60b858.gif";